import { createSlice } from "@reduxjs/toolkit";

export const usuarioSlice = createSlice({
    name: "usuario",
    initialState: {
      data: {},
      token:"",
      tokenFile:""
      },
    reducers: {
        setUsuarioData: (state, action) => {
        state.data = action.payload;
      },
      setToken: (state, action) => {
        state.token = action.payload;
      },
      setTokenFile: (state, action) => {
        state.tokenFile = action.payload;
      }
    }
  });
export const { setUsuarioData, setToken,setTokenFile } = usuarioSlice.actions;

export default usuarioSlice.reducer;

